import { useLocation } from "wouter";
import FluffLogo from "@/components/FluffLogo";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-[#F5F8FC]">
      {/* Minimal header */}
      <header className="w-full bg-white border-b border-[#D0D8E4]">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-center">
          <FluffLogo className="h-11 w-auto" color="#1a1a1a" />
        </div>
      </header>

      {/* Centered content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <p className="text-[#8BA4C0] text-sm font-medium tracking-widest uppercase mb-3">
            Page not found
          </p>
          <h1 className="text-6xl font-bold text-[#004C99] mb-4" style={{ fontFamily: "'Recoleta', serif" }}>
            404
          </h1>
          <p className="text-[#666] text-base leading-relaxed mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <button
            onClick={() => setLocation("/")}
            className="inline-flex items-center justify-center px-8 py-3 bg-[#004C99] text-white text-sm font-semibold rounded-full hover:bg-[#0066CC] transition-colors duration-200"
          >
            Back to FluffCo
          </button>
        </div>
      </main>
    </div>
  );
}
